import { toast } from 'react-toastify';

export default {
  ValidateForm(form) {
    if(!form.name) {
      toast.warning("Name is empty!")
      return false

    } else if(!form.abbreviations) {
      toast.warning("Abbreviations is empty!")
      return false

    } else if(!form.country) {
      toast.warning("Country is empty!")
      return false
    }

    return true
  }
}



// WEBPACK FOOTER //
// ./src/App/superuser/province/helper/form.js